import { useEffect, useRef } from 'react';

import { useEnvironment, useUser } from '#/contexts/UserEnvironmentContext';
import { useI18n } from '#/i18n/hooks/useI18n';
import { onClientHydrated } from '#/rendering/state/renderingState';
import { initializeAds } from '#/zustand-stores/adStore';

export function useAdManager(noAds = false) {
  const { locale } = useI18n();
  const { user } = useUser();
  const { environment } = useEnvironment();

  const adManagerLoadedRef = useRef(false);

  useEffect(() => {
    onClientHydrated(() => {
      // @TODO: Can the environment be `null` before hydration?
      if (!noAds && environment && !adManagerLoadedRef.current) {
        initializeAds({ user, environment, locale });
        adManagerLoadedRef.current = true;
      }
    });
  }, [locale, environment, noAds, user]);
}
